module.exports = __webpack_public_path__ + "static/media/chip-tarjeta.6611645b.png";